/** localStorage key: email used for in-progress magic-link sign-in (Firebase pattern). */
export const EMAIL_SIGNIN_STORAGE_KEY = "uw_ss_email_link_pending";
